export const FETCH_SUPPLIERS = "fetchSuppliers";
export const FETCH_SUPPLIER = "fetchSupplier";
export const CREATE_SUPPLIER = "createSupplier";
export const UPDATE_SUPPLIER = "updateSupplier";
export const DELETE_SUPPLIER = "deleteSupplier";

export const FETCH_PRODUCTS = "fetchProducts";
export const FETCH_ALL_PRODUCTS = "fetchAllProducts";
export const FETCH_PRODUCT = "fetchProduct";
export const CREATE_PRODUCT = "createProducts";
export const UPDATE_PRODUCT = "updateProduct";
export const DELETE_PRODUCT = "deleteProduct";



// WEBPACK FOOTER //
// ./src/store/actions.type.js